import { h } from '@stencil/core';
import cn from 'classnames';
import { columnTypes, send, downloadDocumentEvent } from '@pes-ui/utils';
import { isViewOnline } from '../../../globals/software-documents/utils';
export class PesSoftwareModalRow {
  constructor() {
    this.getDownloadLink = () => {
      var _a, _b, _c;
      if (!isViewOnline(this.documentName)) {
        return this.link;
      }
      if (((_a = this.downloadAll) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.files) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return this.downloadAll;
      }
      if (((_c = this.files) === null || _c === void 0 ? void 0 : _c.length) === 1) {
        return this.files[0].link;
      }
      return null;
    };
    this.cells = undefined;
    this.fileType = undefined;
    this.link = undefined;
    this.documentReference = undefined;
    this.documentName = undefined;
    this.documentType = undefined;
    this.downloadAll = undefined;
    this.files = undefined;
    this.labels = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getCellByType(cell) {
    var _a;
    const { type, text, mobileLabel } = cell;
    if (type === columnTypes.VERSIONS) {
      return (h("pes-software-modal-cell", { class: cn('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, h("a", { class: "pes-software-modal-row__link", target: isViewOnline(this.documentName) ? '_blank' : '_self', href: this.link, onClick: () => this.onLinkClick(this.documentReference, this.documentName, this.documentType) }, h("pes-document-icon", { class: "pes-software-modal-row__icon", type: this.fileType }), text)));
    }
    if (type === columnTypes.LINK) {
      if (isViewOnline(this.documentName) && ((_a = this.files) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        const { documentReference, documentName, documentType } = this.files[0];
        return this.buildLink(type, false, this.getDownloadLink(), documentReference, documentName, documentType);
      }
      return this.buildLink(type, false, this.getDownloadLink(), this.documentReference, this.documentName, this.documentType);
    }
    if (type === columnTypes.ONLINELINK) {
      return this.buildLink(type, isViewOnline(this.documentName), isViewOnline(this.documentName) ? this.link : '', this.documentReference, this.documentName, this.documentType);
    }
    return (h("pes-software-modal-cell", { class: cn('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, Boolean(text) && Boolean(mobileLabel) && (h("span", { class: "pes-software-modal-row__label" }, mobileLabel, ": ")), text));
  }
  buildLink(type, isLinkExternal, link, documentReference, documentName, documentType) {
    return (h("pes-software-modal-cell", { class: cn('pes-software-modal-row__cell', type && `pes-software-modal-row__cell--${type}`), type: type }, h("a", { class: "pes-software-modal-row__download-link", target: isLinkExternal ? '_blank' : '_self', href: link, onClick: () => this.onLinkClick(documentReference, documentName, documentType) }, link && (h("se-icon", { class: "pes-software-modal-row__download-icon", size: "micro" }, isLinkExternal ? 'body_eye' : 'action_download_stroke')))));
  }
  onLinkClick(documentReference, documentName, documentType) {
    send(downloadDocumentEvent, {
      documentReference,
      documentName,
      documentType,
    });
  }
  render() {
    return (h("div", { class: "pes-software-modal-row" }, this.cells.map(this.getCellByType.bind(this))));
  }
  static get is() { return "pes-software-modal-row"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-software-modal-row.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-software-modal-row.css"]
    };
  }
  static get properties() {
    return {
      "cells": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Array<PESSoftwareModalCell>",
          "resolved": "PESSoftwareModalCell[]",
          "references": {
            "Array": {
              "location": "global"
            },
            "PESSoftwareModalCell": {
              "location": "import",
              "path": "../pes-software-modal-content/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Array of data for cells of the row"
        }
      },
      "fileType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines filetype. Used to determine icon shown in the row."
        },
        "attribute": "file-type",
        "reflect": false
      },
      "link": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Link in the first cell of the row"
        },
        "attribute": "link",
        "reflect": false
      },
      "documentReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Document id. Used for GA event."
        },
        "attribute": "document-reference",
        "reflect": false
      },
      "documentName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Document name. Used for GA event."
        },
        "attribute": "document-name",
        "reflect": false
      },
      "documentType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Document type. Used for GA event."
        },
        "attribute": "document-type",
        "reflect": false
      },
      "downloadAll": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Link to download all files."
        },
        "attribute": "download-all",
        "reflect": false
      },
      "files": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TDocumentDetails[]",
          "resolved": "TDocumentDetails[]",
          "references": {
            "TDocumentDetails": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Files details info to get link."
        }
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
